import { dist } from "vector";
import { LinearDisplayFormat, Dimension, Quantity } from "dimtext";
import { multiplier } from "@local/extensions/utilities/scales.js";
import { Sentry } from "#src/glitchtip.js";

function formatLength(lenIn, ds) {
  const unit = ds.displayUnit === "inches" ? "in" : "mm";

  if (ds.displayUnit === "inches") {
    const feet = Math.floor(lenIn / 12);
    const inches = lenIn % 12;
    if (feet > 0) {
      const inDist = new Dimension(new Quantity(inches, "inches"));
      const inStr = inDist.format(
        LinearDisplayFormat[ds.dimFormat],
        ds.dimPrecision,
        {
          displayUnit: "inches",
        },
      );
      if (inStr === "12") {
        return `${feet + 1}ft`;
      } else {
        return `${feet}ft ${inStr}in`;
      }
    } else {
      try {
        const inDist = new Dimension(new Quantity(lenIn, "inches"));
        const inStr = inDist.format(
          LinearDisplayFormat[ds.dimFormat],
          ds.dimPrecision,
          {
            displayUnit: "inches",
          },
        );
        return `${inStr}in`;
      } catch (e) {
        Sentry.captureException(e);
        console.log("Error formatting dimension:", e);
        console.log("Length in inches:", lenIn);
        return null;
      }
    }
  } else {
    const dtDist = new Dimension(new Quantity(lenIn, "inches"));
    const str = dtDist.format(
      LinearDisplayFormat[ds.dimFormat],
      ds.dimPrecision,
      {
        displayUnit: ds.displayUnit,
      },
    );
    return `${str}${unit}`;
  }
}

function lengthDim(ptA, ptB, scale, ds, shiftDown) {
  if (ptA.index !== ptB.index) return null;

  let d;
  if (shiftDown) {
    const dx = Math.abs(ptA.x - ptB.x);
    const dy = Math.abs(ptA.y - ptB.y);
    if (dx > dy) {
      d = dx;
    } else {
      d = dy;
    }
  } else {
    d = dist(ptA, ptB);
  }

  const dIn = (d / 300) * multiplier(scale); // drawing is in inches at 300dpi

  if (!Number.isFinite(dIn)) return null;

  return formatLength(dIn, ds);
}

function rectangleDims(ptA, ptB, scale, ds) {
  if (ptA.index !== ptB.index) return null;

  const w = Math.abs(ptA.x - ptB.x);
  const h = Math.abs(ptA.y - ptB.y);

  const wIn = (w / 300) * multiplier(scale);
  const hIn = (h / 300) * multiplier(scale);
  if (!Number.isFinite(wIn) || !Number.isFinite(hIn)) return null;

  const strW = formatLength(wIn, ds);
  const strH = formatLength(hIn, ds);
  const areaIn = wIn * hIn;
  const areaFt = areaIn / 144;
  const strA = areaFt.toFixed(2) + "sf";

  return [strW, strH, strA];
}

export { lengthDim, rectangleDims };
